import React, { Component } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import withSounds from 'containers/withSounds';
import A11ySvg from 'components/A11ySvg';
import LoadingIndicator from 'components/LoadingIndicator';
import Validators from 'utils/fieldValidators';
import { ReactComponent as ModalCloseIcon } from 'resources/cross.svg';
import './PrizeCodeRedemptionWindow.css';

const ButtonWithSounds = withSounds({ mouseEnterSound: true })(Button);

class PrizeCodeRedemptionWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prizeCodeInput: '',
      submitted: false,
      success: false,
      result: null,
      showModal: true
    };

    this.handleClose = this.handleClose.bind(this);
    this.redeemBtnClicked = this.redeemBtnClicked.bind(this);
    this.handleUUIDInputChange = this.handleUUIDInputChange.bind(this);
  }

  handleClose() {
    this.setState({
      showModal: false
    });
    this.props.redirectToHome();
  }

  redeemBtnClicked() {
    const { prizeCodeInput } = this.state;
    this.setState({
      submitted: true
    });

    this.props
      .awardAnonymousPrize(prizeCodeInput)
      .then(resp => {
        let result = null;
        let success = false;
        if (resp && resp.data && resp.data.awardAnonymousPrize) {
          result = resp.data.awardAnonymousPrize;
          success = resp.data.awardAnonymousPrize.success;
        }
        this.setState({
          submitted: false,
          success: success,
          result: result
            ? result
            : { errorMessage: 'Prize code redemption error. Please try again.' }
        });
      })
      .catch(() => {
        this.setState({
          submitted: false,
          success: false,
          result: {
            errorMessage: 'Prize code redemption error. Please try again.'
          }
        });
      });
  }

  getDialogClose() {
    return (
      <div className={'modal-close-button'}>
        <Link to={'/'}>
          <A11ySvg component={ModalCloseIcon} alt="Close" />
        </Link>
      </div>
    );
  }

  handleUUIDInputChange(event) {
    this.setState({
      prizeCodeInput: event.target.value.trim(),
      result: null
    });
  }

  validateUUID(prizeCode) {
    if (!prizeCode) {
      return 'Required';
    } else {
      return Validators.uuidFormat(prizeCode);
    }
  }

  render() {
    const { prizeCodeInput, submitted, result, success, showModal } =
      this.state;
    const validateUUIDError = this.validateUUID(prizeCodeInput);
    const formValid = !validateUUIDError;
    const formInputEmpty = prizeCodeInput.trim() === '';

    return (
      <Modal
        className={`modal-dialog-prizecode-redemption-window ${
          showModal ? 'preference-in' : 'preference-out'
        }`}
        onHide={this.handleClose}
        show={showModal}
      >
        <Modal.Body>
          {this.getDialogClose()}
          <div className="title">Prize Code Redemption</div>
          <div className="label">
            Congratulations on your Wind Creek Battle Challenge Win!
          </div>
          <div className="locations">
            <FormControl
              className="prizecode-input"
              placeholder="Please enter prize code"
              disabled={success && result}
              value={this.state.prizeCodeInput}
              onChange={this.handleUUIDInputChange}
            />
            {!success && (
              <ButtonWithSounds
                disabled={!formValid || submitted}
                className="redeem-button"
                variant="success"
                onClick={this.redeemBtnClicked}
              >
                Redeem
              </ButtonWithSounds>
            )}
            {submitted && <LoadingIndicator overlay />}
            {success && (
              <ButtonWithSounds
                className="redeem-button"
                variant="primary"
                onClick={this.handleClose}
              >
                Close
              </ButtonWithSounds>
            )}
            {success && result && (
              <React.Fragment>
                <div className="label-result">
                  Prize code redemption is successful.
                </div>
                {(!result.validTo || !result.validFrom) && (
                  <div className="label-result">{`${result.prize.name} has been added to your account.`}</div>
                )}
                {result.validTo && result.validFrom && (
                  <div className="label-result">{`${result.prize.name} valid from ${result.validFrom} to ${result.validTo} has been added to your account.`}</div>
                )}
                <div className="label-result">
                  View your profile to see all your offers and prizes.
                </div>
              </React.Fragment>
            )}
            {!success && result && (
              <div className="label-result">{result.errorMessage}</div>
            )}
            {!formInputEmpty && !formValid && (
              <div className="label-result">
                The prize code entered is not valid.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const MUTATION_AWARD_ANONYMOUS_PRIZE = gql`
  mutation awardAnonymousPrize($input: AwardAnonymousPrizeInput!) {
    awardAnonymousPrize(input: $input) {
      success
      validTo
      validFrom
      prize {
        name
        category
      }
      cmpPrizeCode
      errorMessage
    }
  }
`;

const withAwardAnonymousPrize = graphql(MUTATION_AWARD_ANONYMOUS_PRIZE, {
  props: ({ ownProps, mutate }) => ({
    awardAnonymousPrize: requestId =>
      mutate({
        variables: {
          input: {
            requestId: requestId
          }
        }
      })
  })
});

const mapDispatchToProps = dispatch => ({
  redirectToHome: () => dispatch(push('/'))
});

const withConnect = connect(null, mapDispatchToProps);

export default withConnect(withAwardAnonymousPrize(PrizeCodeRedemptionWindow));
